// src/App.js
import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import "./assets/css/tailwind.css";
import "./assets/css/materialdesignicons.min.css";

import IndexTwo from "./pages/index/index-two";
import Aboutus from "./pages/aboutus";
import Helpcenter from "./pages/helpcenter/helpcenter";
import HelpcenterFaq from "./pages/helpcenter/helpcenter-faqs";
import HelpcenterSupport from "./pages/helpcenter/helpcenter-support";
import Terms from "./pages/utility/terms";
import Privacy from "./pages/utility/privacy";
import Blogs from "./pages/blog/blogs";
import BlogStandard from "./pages/blog/blog-standard";
import BlogDetail from "./pages/blog/blog-detail";
import Contact from "./pages/contact";
import Apply from "./pages/Apply";
import Comingsoon from "./pages/special/comingsoon";
import DynamicTrackingCode from "./components/TrackingCode";
import Portfolio from "./pages/portfolio";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import avatar from "./avatar.PNG"


function App() {
  useEffect(() => {
    const enquiryButton = document.querySelector('.npfWidgetButton');
    if (enquiryButton) {
      enquiryButton.click();
    }
  }, []);

  return (
    <>
    <DynamicTrackingCode />
      <Routes>
        <Route path="/" element={<IndexTwo />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/helpcenter" element={<Helpcenter />} />
        <Route path="/helpcenter-faqs" element={<HelpcenterFaq />} />
        <Route path="/helpcenter-support" element={<HelpcenterSupport />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/blogs" element={<BlogStandard />} />
        <Route path="/blog-standard" element={<BlogStandard />} />
        <Route path="/blog-detail" element={<BlogDetail />} />
        <Route path="/blog-detail/:id" element={<BlogDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/comingsoon" element={<Comingsoon/>}/>
        <Route path="/portfolio" element={<Portfolio/>}/>
      </Routes>
      <FloatingWhatsApp
        phoneNumber="+263716470763"
        accountName="Sky Global Education"
        avatar={avatar}
        statusMessage="Typically replies within 1 hour" 
        chatMessage="Hello! 🌟 How can we assist you with your educational journey?"
        placeholder="Type your message here..." 
        messageDelay={2}
        chatboxHeight={320}
        chatboxStyle={{ backgroundColor: "#02010bff", color: "#000" }}
        chatboxClassName="custom-chatbox-class"
        notification={true}
        notificationDelay={60} 
        notificationLoop={0}
        allowClickAway={true}
        allowEsc={true} 
        darkMode={false}
        style={{ bottom: '20px', right: '20px' }}
        className="custom-floating-whatsapp-class" 
        buttonStyle={{ backgroundColor: "#07031aff", color: "#fff" }} 
        buttonClassName="custom-button-class"
        onClick={(event) => console.log("WhatsApp button clicked", event)}
        onSubmit={(event, formValue) => console.log("Message submitted", formValue)}
        onClose={() => console.log("Chatbox closed")}
        onNotification={() => console.log("Notification triggered")} 
        onLoopDone={() => console.log("Notification loop done")} 
      />

    </>
  );
}

export default App;
